export const TaskTypeKey = 'task-type';
export const TaskTypesKey = 'task-types';